import { AnimatePresence, motion } from 'framer-motion';
import { useEffect } from 'react';
import { Icon } from './Icon.jsx';

export function Modal({ open, title, onClose, children, footer, size = 'md', dismissible = true }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === 'Escape' && dismissible) onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose, dismissible]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="modal-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.18 }}
          onMouseDown={(e) => {
            if (dismissible && e.target === e.currentTarget) onClose?.();
          }}
        >
          <motion.div
            className={`modal ${size === 'lg' ? 'lg' : ''}`}
            initial={{ opacity: 0, scale: 0.96, y: 12 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.97, y: 6 }}
            transition={{ type: 'spring', stiffness: 320, damping: 28 }}
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-head">
              <h3>{title}</h3>
              {dismissible && (
                <button className="btn ghost icon sm close" onClick={onClose} aria-label="Fermer">
                  <Icon name="close" size={16} />
                </button>
              )}
            </div>
            <div className="modal-body">{children}</div>
            {footer && <div className="modal-foot">{footer}</div>}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
